import { Observable, Subscription } from 'rxjs';
import { AppModalListProductKonvaComponent } from './../app-modal-list-product-konva/app-modal-list-product-konva.component';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import Konva from 'konva';
import { DocumentService } from '@app/api/api';
import * as moment from 'moment';
@Component({
  selector: 'meu-app-draw-image',
  templateUrl: './app-draw-image.component.html',
  styleUrls: ['./app-draw-image.component.scss']
})
export class AppDrawImageComponent implements OnInit {
  @ViewChild('chooseFile', { static: false }) chooseFile: ElementRef;
  @Input() widthInput: any;
  @Input() heightInput: any;
  @Input() documentId: any;
  @Output() onChangeData = new EventEmitter();
  @Output() onChangeImage = new EventEmitter();
  constructor(
    private dialog: MatDialog,
    private documentService: DocumentService,
    private ref: ChangeDetectorRef,
  ) { }
  stage: Konva.Stage;
  layer: Konva.Layer;
  width = window.innerWidth / 2;
  height = window.innerHeight * 0.7;
  pointStage = { x: 1, y: 1 };
  newScale = 1;

  paddingMenu: 5;
  topMenu;
  groupMenu: Konva.Group;
  menuGroupBackgroud: Konva.Rect;
  widthIconMenu: 0;
  xIconMenu: 20;
  penMenu: any;
  rectangleMenu: any;
  circleMenu: any;
  imageMenu: any;
  lstRectangle: any = [];
  lstTranform: any = [];
  listGroupMenu: any = [];

  isRenderLine: boolean = false;
  lstPointLine: any = [];
  lstLineDraff: any = [];
  lstHide: any = [];
  selectedID: any;
  subscriptions: Subscription[];
  subcribe = new Observable<boolean>(observer => {
    // Subscriber fn...
  });
  theImg: Konva.Image;
  ngOnInit() {
    this.pointStage = { x: 1, y: 1 };
    this.newScale = 1;
    this.width = document.getElementById("containerKonva").offsetWidth;
    this.height = 500;
    this.layer = new Konva.Layer();
    // generate Stage
    this.stage = new Konva.Stage({
      container: 'containerKonva',
      width: this.width,
      height: this.height,
      draggable: true,
    });
    var scaleBy = 1.1;
    this.stage.on('wheel', e => {
      e.evt.preventDefault();
      var oldScale = this.stage.scaleX();
      var mousePointTo = {
        x: this.stage.getPointerPosition().x / oldScale - this.stage.x() / oldScale,
        y: this.stage.getPointerPosition().y / oldScale - this.stage.y() / oldScale
      };
      this.newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
      if (this.newScale < 0.1) this.newScale = 0.1;
      if (this.newScale > 1.8) this.newScale = 1.8;
      this.stage.scale({ x: this.newScale, y: this.newScale });
      this.pointStage = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / this.newScale) *
          this.newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / this.newScale) *
          this.newScale
      };
      this.reRenderMenu(this.pointStage, this.newScale)
      this.stage.position(this.pointStage);
      this.stage.draw();
    });

    this.stage.on('dragmove', e => {
      if (e.currentTarget._lastPos != null) {
        this.pointStage = { x: e.currentTarget.attrs.x, y: e.currentTarget.attrs.y };
        this.reRenderMenu(this.pointStage, this.newScale)
      }
    });
    this.stage.on('mousedown', e => {
      if (this.isRenderLine) {
        const mousePos = this.getRelativePointerPosition(this.stage);
        // const x = mousePos.x * this.newScale;
        // const y = mousePos.y * this.newScale;
        const x = mousePos.x;
        const y = mousePos.y;
        this.lstPointLine.push(x);
        this.lstPointLine.push(y);
        if (this.lstPointLine.length > 0) {
          if (this.lstPointLine.length == 2) {
            var circle = new Konva.Circle({
              x: x,
              y: y,
              radius: 5,
              stroke: '#f4d21b',
              fill: '#f4d21b',
              strokeWidth: 1,
              draggable: false,
            });
            circle.on('click', (e) => {
              this.lstPointLine[this.lstPointLine.length - 2] = this.lstPointLine[0];
              this.lstPointLine[this.lstPointLine.length - 1] = this.lstPointLine[1];
              for (let i = 0; i < this.lstLineDraff.length; i++) {
                this.lstLineDraff[i].destroy();
              }
              let lstPointPoly = [];
              for (let i = 0; i < this.lstPointLine.length; i += 2) {
                lstPointPoly.push({
                  x: this.lstPointLine[i],
                  y: this.lstPointLine[i + 1]
                })
              }
              this.renderRegularPolygon("00000000-0000-0000-0000-000000000000", null, lstPointPoly, []);
              circle.hide();
              this.isRenderLine = false;
              this.lstPointLine = [];
              this.stage.container().style.cursor = '';
              this.layer.draw();

            });
            this.layer.add(circle);
            this.layer.draw();
          }
          this.renderLine();
        }
      }
      //this.mainMenu.reRender();
    });
    this.renderMenu();
    // this.renderRectagle(159,40,8.97262661489599,0.9999999999999999,1.4039030748916375);
    // this.renderCircle(159,40,89.97026425328754,0.9999999999999999,1.4039030748916375);
    //this.getDocumentById();

  }
  renderStage() {
    this.stage = new Konva.Stage({
      container: 'containerKonva',
      width: this.width,
      height: this.height,
      draggable: true,
    });
    var scaleBy = 1.1;
    this.stage.on('wheel', e => {
      e.evt.preventDefault();
      var oldScale = this.stage.scaleX();
      var mousePointTo = {
        x: this.stage.getPointerPosition().x / oldScale - this.stage.x() / oldScale,
        y: this.stage.getPointerPosition().y / oldScale - this.stage.y() / oldScale
      };
      this.newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
      if (this.newScale < 0.1) this.newScale = 0.1;
      if (this.newScale > 1.8) this.newScale = 1.8;
      this.stage.scale({ x: this.newScale, y: this.newScale });
      this.pointStage = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / this.newScale) *
          this.newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / this.newScale) *
          this.newScale
      };
      this.reRenderMenu(this.pointStage, this.newScale)
      this.stage.position(this.pointStage);
      this.stage.draw();
    });

    this.stage.on('dragmove', e => {
      if (e.currentTarget._lastPos != null) {
        this.pointStage = { x: e.currentTarget.attrs.x, y: e.currentTarget.attrs.y };
        this.reRenderMenu(this.pointStage, this.newScale)
      }
    });
    this.stage.on('mousedown', e => {
      if (this.isRenderLine) {
        const mousePos = this.getRelativePointerPosition(this.stage);
        // const x = mousePos.x * this.newScale;
        // const y = mousePos.y * this.newScale;
        const x = mousePos.x;
        const y = mousePos.y;
        this.lstPointLine.push(x);
        this.lstPointLine.push(y);
        if (this.lstPointLine.length > 0) {
          if (this.lstPointLine.length == 2) {
            var circle = new Konva.Circle({
              x: x,
              y: y,
              radius: 5,
              stroke: '#f4d21b',
              fill: '#f4d21b',
              strokeWidth: 1,
              draggable: false,
            });
            circle.on('click', (e) => {
              this.lstPointLine[this.lstPointLine.length - 2] = this.lstPointLine[0];
              this.lstPointLine[this.lstPointLine.length - 1] = this.lstPointLine[1];
              for (let i = 0; i < this.lstLineDraff.length; i++) {
                this.lstLineDraff[i].destroy();
              }
              let lstPointPoly = [];
              for (let i = 0; i < this.lstPointLine.length; i += 2) {
                lstPointPoly.push({
                  x: this.lstPointLine[i],
                  y: this.lstPointLine[i + 1]
                })
              }
              this.renderRegularPolygon("00000000-0000-0000-0000-000000000000", null, lstPointPoly, []);
              circle.hide();
              this.isRenderLine = false;
              this.lstPointLine = [];
              this.stage.container().style.cursor = '';
              this.layer.draw();

            });
            this.layer.add(circle);
            this.layer.draw();
          }
          this.renderLine();
        }
      }
      //this.mainMenu.reRender();
    });
    this.renderMenu();
  }
  getDataServer(listDataShape) {
    for (let i = 0; i < listDataShape.length; i++) {
      let dataServer = listDataShape[i].data;
      switch (dataServer.type) {
        case "rectangle":
          this.renderRectagle(dataServer.id, dataServer.unique_id, dataServer.center.x, dataServer.center.y, dataServer.rotation, dataServer.scaleX, dataServer.scaleY, listDataShape[i].shapeRefs);
          break;
        case "circle":
          this.renderCircle(dataServer.id, dataServer.unique_id, dataServer.center.x, dataServer.center.y, dataServer.rotation, dataServer.scaleX, dataServer.scaleY, listDataShape[i].shapeRefs);
          break;
        case "polygon":
          this.renderRegularPolygon(dataServer.id, dataServer.unique_id, dataServer.polygon_points, listDataShape[i].shapeRefs);
          break;
        default:
        // code block
      }
    }
  }
  saveData() {
    this.onChangeData.emit(this.lstRectangle)
  }
  getRelativePointerPosition(node) {
    var transform = node.getAbsoluteTransform().copy();
    // to detect relative position we need to invert transform
    transform.invert();

    // get pointer (say mouse or touch) position
    var pos = node.getStage().getPointerPosition();

    // now we can find relative point
    return transform.point(pos);
  }
  renderLine() {
    var poly = new Konva.Line({
      points: this.lstPointLine,
      fill: "yellow",
      stroke: '#f4d21b',
      strokeWidth: 1,

    });
    // add the shape to the layer
    this.lstLineDraff.push(poly);
    this.layer.add(poly);
    this.layer.draw();
  }
  renderRegularPolygon(id, uni_id, list_points, shapeRefs) {
    var list;
    var remove;
    const localDate = new Date();
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    let _this = this;
    let lst_point_draft = [];
    for (let i = 0; i < list_points.length; i++) {
      lst_point_draft.push(list_points[i].x);
      lst_point_draft.push(list_points[i].y);
    }
    var poly = new Konva.Line({
      id: id,
      points: lst_point_draft,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 1,
      draggable: false,
      opacity: 0.5,
      closed: true,
    });
    poly.moveToBottom();
    poly.on('transformstart', function () {
    });
    poly.on('transform', function (e) {
      let rotationRectangle = poly.rotation();
      groupMenu.setAttr("x", _this.lstPointLine[0] + poly.x());
      groupMenu.setAttr("y", _this.lstPointLine[1] + poly.y());
    });
    poly.addEventListener('mousedown', function () {
      for (let i = 0; i < _this.lstTranform.length; i++) {
        if (_this.lstTranform[i].id() == unique_id) {
          _this.lstTranform[i].show();
          _this.listGroupMenu[i].show();
        }
        else {
          _this.lstTranform[i].hide();
          _this.listGroupMenu[i].hide();
        }
      }
    });

    var tr = new Konva.Transformer({
      id: unique_id,
      anchorStroke: '#f4d21b',
      anchorFill: '#f4d21b',
      borderStroke: "#494c55",
      nodes: [poly],
    });

    tr.hide();
    this.lstTranform.push(tr);
    var groupMenu = new Konva.Group({
      id: unique_id,
      x: lst_point_draft[0],
      y: lst_point_draft[1] - 30,
      draggable: false
    });
    this.listGroupMenu.push(groupMenu);
    var rectMenu = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 25,
      stroke: '#f4d21b',
      fill: "#ffffff",
      strokeWidth: 1,
      draggable: false,
    });
    groupMenu.add(rectMenu);
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-list.svg', (button) => {
      button.setAttrs({
        x: 5,
        y: 0,
        width: 23,
        height: 23,
        // shadowOffset: {
        //   x: 1,
        //   y: 1
        // },
        // shadowBlur: 1,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        this.openModalEditProductCatalog(this.lstRectangle[indexRect].shapeRefs, unique_id);
      });
      list = button;
      groupMenu.add(button)
    })
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-remove.svg', (button) => {

      button.setAttrs({
        x: 50,
        y: 0,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        let index = _this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        _this.lstRectangle.splice(index, 1);
        poly.hide();
        groupMenu.hide();
        // for (let i = 0; i < _this.lstTranform.length; i++) {
        //   if (_this.lstTranform[i].id() == unique_id) {
        //     _this.lstTranform[i].hide();
        //     _this.listGroupMenu[i].hide();
        //   }
        // }
        _this.saveData();
      });
      remove = button;
      groupMenu.add(button)
    })
    //group.add(groupMenu);
    groupMenu.hide();
    this.layer.add(poly, groupMenu);
    this.layer.draw();
    this.lstRectangle.push({
      data: {
        id: id,
        center: list_points[0],
        document_id: this.documentId,
        height: null,
        radius: null,
        polygon_points: list_points,
        type: "polygon",
        width: null,
        unique_id: unique_id
      },
      shapeRefs: shapeRefs

    });

    this.saveData();
  }
  renderMenu() {
    this.groupMenu = new Konva.Group({
      x: 10,
      y: 10,
      rotation: 0,
      draggable: false
    });
    const that = this;
    this.menuGroupBackgroud = new Konva.Rect(
      {
        x: 0,
        y: 0,
        width: 40,
        height: 150,
        fill: 'white',
        stroke: '#f4d21b',
        strokeWidth: 1,
        draggable: false
      }
    );
    this.groupMenu.add(this.menuGroupBackgroud);

    Konva.Image.fromURL('/assets/media/icons/svg/catalog/konva-pen.svg', (button) => {

      button.setAttrs({
        x: 8,
        y: 18,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('click', (e) => {
        this.stage.container().style.cursor = 'crosshair';
        this.isRenderLine = true;
      });
      this.penMenu = button;
      that.groupMenu.add(button);
      that.groupMenu.moveToTop();
      that.layer.draw();
      button.moveToTop();

    });
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/konva-rectangle.svg', (button) => {
      button.setAttrs({
        x: 8,
        y: 50,
        width: 23,
        height: 23,
        // shadowOffset: {
        //   x: 1,
        //   y: 1
        // },
        // shadowBlur: 1,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        this.renderRectagle("00000000-0000-0000-0000-000000000000", null, 50, 30, 1, 1, 1, []);
      });
      that.rectangleMenu = button;
      that.groupMenu.add(button);
      that.groupMenu.moveToTop();
      that.layer.draw();
      button.moveToTop();

    });
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/konva-circle.svg', (button) => {
      button.setAttrs({
        x: 8,
        y: 80,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        this.renderCircle("00000000-0000-0000-0000-000000000000", null, 100, 100, 0, 1, 1, []);
      });
      that.circleMenu = button;
      that.groupMenu.add(button);
      that.groupMenu.moveToTop();
      that.layer.draw();
      button.moveToTop();
    });
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/konva-image.svg', (button) => {
      button.setAttrs({
        x: 8,
        y: 115,
        width: 23,
        height: 23,
        enhance: 1,
      });

      button.on('click', (e) => {
        document.getElementById("inputImage").click();
      });
      button
      that.imageMenu = button;
      that.groupMenu.add(button);
      that.groupMenu.moveToTop();
      that.layer.draw();
      button.moveToTop();
    });
    this.layer.add(this.groupMenu);
    this.stage.add(this.layer);

  }
  reRenderMenu(newPos, newScale) {
    var point = { x: 10 / newScale - newPos.x / newScale, y: 10 / newScale - newPos.y / newScale }
    // this.groupMenu.setAttr("width", 300 / newScale)
    // this.groupMenu.setAttr("height", 50 / newScale)
    this.groupMenu.position(point);
    this.groupMenu.moveToTop();
    this.menuGroupBackgroud.setAttr("width", 40 / newScale)
    this.menuGroupBackgroud.setAttr("height", 150 / newScale)
    this.groupMenu.add(this.menuGroupBackgroud);
    this.penMenu.setAttr("width", 23 / newScale)
    this.penMenu.setAttr("height", 23 / newScale)
    this.rectangleMenu.setAttr("width", 23 / newScale)
    this.rectangleMenu.setAttr("height", 23 / newScale)
    this.circleMenu.setAttr("width", 23 / newScale)
    this.circleMenu.setAttr("height", 23 / newScale)
    this.imageMenu.setAttr("width", 23 / newScale)
    this.imageMenu.setAttr("height", 23 / newScale)

    var pointPen = { x: 8 / newScale, y: 18 / newScale }
    this.penMenu.position(pointPen);

    var pointRectangle = { x: 8 / newScale, y: 50 / newScale }
    this.rectangleMenu.position(pointRectangle);

    var pointCircle = { x: 8 / newScale, y: 80 / newScale }
    this.circleMenu.position(pointCircle);

    var pointImage = { x: 8 / newScale, y: 115 / newScale }
    this.imageMenu.position(pointImage);

    // let x = 10;
    // for (const buttonItem of this.actionButtons) {
    //     buttonItem.reRender(x / newScale, 10 / newScale, 20 / newScale, 20 / newScale, 5 / newScale)
    //     x += 30;
    // }
  }
  onFileInput(ev) {

    var _this = this;
    if (ev.target.files.length > 0) {
      this.layer.removeChildren();
      this.ngOnInit();
      this.lstRectangle = [];
      this.saveData();
      if (this.theImg != null) {
        this.theImg.destroy();
      }
      var url = URL.createObjectURL(ev.target.files[0]);
      this.onChangeImage.emit(ev.target.files[0])
      var img = new Image();
      img.src = url;
      this.theImg = new Konva.Image({
        image: img,
        x: 50,
        y: 0,
        // width: this.width,
        // height: this.height,
        draggable: false,

      });
      setTimeout(function () {
        _this.layer.add(_this.theImg);
        _this.theImg.moveToBottom();
        _this.layer.draw();
      }, 200);
    }


    // this.theImg.moveToBottom();
    // this.layer.draw();
    // this.layer.batchDraw();
    //this.ref.detectChanges();
  }
  renderImageserver(urlServer) {
    var _this = this;
    var img = new Image();
    img.src = urlServer;
    this.theImg = new Konva.Image({
      image: img,
      x: 50,
      y: 0,
      // width: auto,
      // height: this.height,
      draggable: false,
    });

    setTimeout(function () {
      _this.theImg.moveToBottom();
      _this.layer.add(_this.theImg);
      _this.layer.draw();
    }, 200);


  }
  renderRectagle(id, uni_id, x, y, rotation, scaleX, scaleY, shapeRefs) {
    var list;
    var remove;
    let _this = this;
    const localDate = new Date();
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    this.selectedID = unique_id;
    var group = new Konva.Group({
      x: x,
      y: y,
      // width: 100,
      // height: 50,
      rotation: 0,
      draggable: true,

    });
    group.moveToTop();
    group.on('dragmove', e => {
      let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      this.lstRectangle[indexRect].data.center = { x: group.x(), y: group.y() };
      this.saveData();
    });
    group.on('dragend', e => {
      let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      this.lstRectangle[indexRect].data.center = { x: group.x(), y: group.y() };
      this.saveData();
    });
    var rect = new Konva.Rect({
      x: 0,
      y: 0,
      width: 100,
      height: 50,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 1,
      draggable: false,
      rotation: rotation,
      opacity: 0.5,
      scaleX: scaleX,
      scaleY: scaleY,
    });
    rect.addEventListener('mousedown', function () {
      for (let i = 0; i < _this.lstTranform.length; i++) {
        if (_this.lstTranform[i].id() == unique_id) {
          _this.lstTranform[i].show();
          _this.listGroupMenu[i].show();
          group.moveToTop();
        }
        else {
          _this.lstTranform[i].hide();
          _this.listGroupMenu[i].hide();

        }
      }

    })
    rect.on('transform', function (e) {
      let rotationRectangle = rect.rotation();
      switch (true) {
        case (rotationRectangle == -0):
          groupMenu.setAttr("x", rect.x());
          groupMenu.setAttr("y", rect.y() - 30);
          break;
        case rotationRectangle > 0:
          groupMenu.setAttr("x", rect.x() + 5);
          groupMenu.setAttr("y", rect.y() - 30);
          break;
        case rotationRectangle < 0:
          groupMenu.setAttr("x", rect.x() - 85);
          groupMenu.setAttr("y", rect.y() + 5);
          break;
        default:

      }
    });
    rect.on('transformend', function () {
      let indexRect = _this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      //this.lstRectangle[indexRect].data.center = { x: group.x(), y: group.y() };

      //let index = _this.lstRectangle.findIndex(x => x.unique_id == unique_id);
      _this.lstRectangle[indexRect].data.scaleX = rect.scaleX();
      _this.lstRectangle[indexRect].data.scaleY = rect.scaleY();
      _this.lstRectangle[indexRect].data.rotation = rect.rotation();
      _this.lstRectangle[indexRect].data.center = { x: group.x() + rect.x(), y: group.y() + rect.y() };
      _this.saveData();
    });
    group.add(rect);
    var tr = new Konva.Transformer({
      id: unique_id,
      anchorStroke: '#f4d21b',
      anchorFill: '#f4d21b',
      borderStroke: "#494c55",
      nodes: [rect],
    });
    group.add(tr);
    tr.hide();
    this.lstTranform.push(tr);
    var groupMenu = new Konva.Group({
      id: unique_id,
      x: -80,
      y: -35,
      draggable: false
    });
    var rectMenu = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 25,
      stroke: '#f4d21b',
      fill: "#ffffff",
      strokeWidth: 1,
      draggable: false,
    });
    groupMenu.add(rectMenu);
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-list.svg', (button) => {
      button.setAttrs({
        x: 5,
        y: 0,
        width: 23,
        height: 23,
        // shadowOffset: {
        //   x: 1,
        //   y: 1
        // },
        // shadowBlur: 1,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        this.openModalEditProductCatalog(this.lstRectangle[indexRect].shapeRefs, unique_id);
        tr.hide();
      });
      list = button;
      groupMenu.add(button)
    })
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-remove.svg', (button) => {

      button.setAttrs({
        x: 50,
        y: 0,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        //tr.hide();
        group.hide();
        let index = _this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        _this.lstRectangle.splice(index, 1);
        for (let i = 0; i < _this.lstTranform.length; i++) {
          if (_this.lstTranform[i].id() == unique_id) {
            _this.lstTranform[i].hide();
            _this.listGroupMenu[i].hide();
          }
        }
        _this.saveData();
      });
      remove = button;
      groupMenu.add(button)
    })
    group.add(groupMenu);
    groupMenu.hide();
    this.subcribe.subscribe(res => {
      if (res == true) {
        group.hide();
      }
    });
    this.listGroupMenu.push(groupMenu);
    group.on('mousedown', (e) => {

    });
    //this.layer.add(tr);
    group.moveToTop();
    this.layer.add(group);
    this.layer.draw();
    this.lstRectangle.push({
      data: {
        id: id,
        center: { x: group.x(), y: group.y() },
        document_id: this.documentId,
        height: null,
        radius: null,
        rotation: rect.rotation(),
        scaleX: rect.scaleX(),
        scaleY: rect.scaleY(),
        type: "rectangle",
        width: null,
        unique_id: unique_id,
      },
      shapeRefs: shapeRefs
    }
    );
    this.saveData();
  }
  renderCircle(id, uni_id, x, y, rotation, scaleX, scaleY, shapeRefs) {
    const localDate = new Date();
    var list;
    var remove;
    var _this = this;
    let unique_id = uni_id != null ? uni_id : moment.utc(localDate).valueOf();
    var group = new Konva.Group({
      x: x,
      y: y,
      // width: 100,
      // height: 50,
      rotation: 0,
      draggable: true
    });
    group.moveToTop();
    group.on('dragmove', e => {
      let indexCircle = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      this.lstRectangle[indexCircle].data.center = { x: group.x(), y: group.y() };
      this.saveData();
    });
    group.on('dragend', e => {
      let indexCircle = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      this.lstRectangle[indexCircle].data.center = { x: group.x(), y: group.y() };
      this.saveData();
    });
    var circle = new Konva.Circle({
      x: 0,
      y: 0,
      radius: 50,
      stroke: '#f4d21b',
      fill: '#f4d21b',
      strokeWidth: 1,
      draggable: false,
      opacity: 0.5,
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: rotation
    });

    circle.on('mousedown', function () {
      for (let i = 0; i < _this.lstTranform.length; i++) {
        if (_this.lstTranform[i].id() == unique_id) {
          _this.lstTranform[i].show();
          _this.listGroupMenu[i].show();
          group.moveToTop();
        }
        else {
          _this.lstTranform[i].hide();
          _this.listGroupMenu[i].hide();
        }
      }
    });
    circle.on('transform', function (e) {
      let rotationRectangle = circle.rotation();
      switch (true) {
        case (rotationRectangle == -0):
          groupMenu.setAttr("x", 55);
          groupMenu.setAttr("y", -75);
          break;
        case rotationRectangle > 0 && rotationRectangle < 90:
          groupMenu.setAttr("x", 65);
          groupMenu.setAttr("y", -75);
          break;
        case rotationRectangle > 0 && rotationRectangle > 90:
          groupMenu.setAttr("x", 65);
          groupMenu.setAttr("y", 55);
          break;
        case rotationRectangle < 0 && rotationRectangle > -90:
          groupMenu.setAttr("x", - 145);
          groupMenu.setAttr("y", - 75);
          break;
        case rotationRectangle < 0 && rotationRectangle < -90:
          groupMenu.setAttr("x", -145);
          groupMenu.setAttr("y", 50);
          break;
        default:
      }
    });
    circle.on('transformend', function () {
      let indexCircle = _this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
      //this.lstRectangle[indexCircle].data.center = { x: group.x(), y: group.y() };


      //let index = _this.lstRectangle.findIndex(x => x.unique_id == unique_id);
      _this.lstRectangle[indexCircle].data.scaleX = circle.scaleX();
      _this.lstRectangle[indexCircle].data.scaleY = circle.scaleY();
      _this.lstRectangle[indexCircle].data.rotation = circle.rotation();
      _this.lstRectangle[indexCircle].data.center = { x: group.x() + circle.x(), y: group.y() + circle.y() };
      _this.saveData();
    });
    group.add(circle);
    var tr = new Konva.Transformer({
      id: unique_id,
      anchorStroke: '#f4d21b',
      anchorFill: '#f4d21b',
      borderStroke: "#494c55",
      nodes: [circle],
    });
    this.lstTranform.push(tr);
    group.add(tr);
    tr.hide();
    var groupMenu = new Konva.Group({
      id: unique_id,
      x: -125,
      y: -85,
      draggable: false
    });
    this.listGroupMenu.push(groupMenu);
    var rectMenu = new Konva.Rect({
      x: 0,
      y: 0,
      width: 75,
      height: 25,
      stroke: '#f4d21b',
      fill: "#ffffff",
      strokeWidth: 1,
      draggable: false,
    });
    groupMenu.add(rectMenu);
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-list.svg', (button) => {
      button.setAttrs({
        x: 5,
        y: 0,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        this.openModalEditProductCatalog(this.lstRectangle[indexRect].shapeRefs, unique_id);
        tr.hide();
      });
      list = button;
      groupMenu.add(button)
    })
    Konva.Image.fromURL('/assets/media/icons/svg/catalog/tree-remove.svg', (button) => {
      button.setAttrs({
        x: 50,
        y: 0,
        width: 23,
        height: 23,
        enhance: 1,
      });
      button.on('mousedown', (e) => {
        let index = _this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        _this.lstRectangle.splice(index, 1);
        group.hide();
      });
      remove = button;
      groupMenu.add(button)
    })
    group.add(groupMenu);
    groupMenu.hide();
    group.on('mousedown', (e) => {
      tr.show();
      groupMenu.show();
      this.layer.draw();
    });
    //this.layer.add(tr);
    this.layer.add(group);
    this.layer.draw();
    this.lstRectangle.push({
      data:
      {
        id: id,
        center: { x: group.x(), y: group.y() },
        document_id: this.documentId,
        height: null,
        radius: null,
        rotation: circle.rotation(),
        scaleX: circle.scaleX(),
        scaleY: circle.scaleY(),
        type: "circle",
        width: null,
        unique_id: unique_id,
      }
      , shapeRefs: shapeRefs
    });
    this.saveData();
  }
  openModalEditProductCatalog(shapeRefs, unique_id) {
    const dialogRef = this.dialog.open(AppModalListProductKonvaComponent, {
      width: '800px',
      data: {
        shapeRefs: shapeRefs
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event) {
        let indexRect = this.lstRectangle.findIndex(x => x.data.unique_id == unique_id);
        this.lstRectangle[indexRect].shapeRefs = result.data;
      }
    });
  }

}

